import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  heading: {
    id: 'wishlist.heading',
    defaultMessage: 'My wishlist',
    description: 'Heading for the wishlist page',
  },
  searchPlaceholder: {
    id: 'wishlist.searchPlaceholder',
    defaultMessage: 'Search courses..',
    description: 'Placeholder for the wishlist search input',
  },
  filterButton: {
    id: 'wishlist.filterButton',
    defaultMessage: 'Filter',
    description: 'Label for the filter button on the wishlist page',
  },
  emptyTitle: {
    id: 'wishlist.empty.title',
    defaultMessage: 'No saved courses yet',
    description: 'Empty state title shown when the wishlist has no items',
  },
  emptyCta: {
    id: 'wishlist.empty.cta',
    defaultMessage: 'Explore courses',
    description: 'Empty state call-to-action that navigates the learner to the discover page',
  },
  emptyImageAlt: {
    id: 'wishlist.empty.imageAlt',
    defaultMessage: 'Illustration of a saved course with a heart',
    description: 'Alt text for the wishlist empty state illustration',
  },
  loading: {
    id: 'wishlist.loading',
    defaultMessage: 'Loading wishlist',
    description: 'Screen reader text shown while the wishlist is loading',
  },
  loadError: {
    id: 'wishlist.loadError',
    defaultMessage: 'Unable to load wishlist. Please try again later.',
    description: 'Error message shown when the wishlist fails to load',
  },
  noSearchMatches: {
    id: 'wishlist.noSearchMatches',
    defaultMessage: 'No items match your search.',
    description: 'Message shown when no wishlist items match the active search query',
  },
});

export default messages;
